export enum SubstratePeopleType {
    Person = 'Person',
    Group = 'Group',
    Other = 'Other',
}

export enum SubstratePeopleSubtype {
    OrganizationUser = 'OrganizationUser',
    OrganizationContact = 'OrganizationContact',
    PersonalContact = 'PersonalContact',
    ImplicitContact = 'ImplicitContact',
    ChatImplicitContact = 'ChatImplicitContact',
    UnifiedGroup = 'UnifiedGroup',
    PublicDistributionList = 'PublicDistributionList',
    PersonalDistributionList = 'PersonalDistributionList',
    Room = 'Room',
}
